export default "__VITE_ASSET__DulnyBic__"